import { useTranslation } from 'react-i18next';
import { useCouponPopup } from '~/components/coupon/CouponPopup';
import { CouponDoc } from '~/services/db/coupons/CouponsAPI';
import { CODE_CLIENT_ID } from '~/config/endpoints.config';
import styles from './CouponWonModal.module.css';
import { CouponWonFirstScreen } from './components/CouponWonFirstScreen';
import { useSearchParams } from 'react-router-dom';

export type CouponWonModalProps = {
    coupon: CouponDoc;
};

export function CouponWonModal({ coupon }: CouponWonModalProps) {
    const { t } = useTranslation();
    const { close } = useCouponPopup();
    const [searchParams] = useSearchParams();
    const clientID = searchParams.get(CODE_CLIENT_ID);
    const scopeLabels: Record<string, string> = {
        daily: t('coupon.records.daily'),
        weekly: t('coupon.records.weekly'),
        monthly: t('coupon.records.monthly'),
        yearly: t('coupon.records.yearly'),
        'all-time': t('coupon.records.allTime'),
        participation: t('coupon.records.participation'),
    };

    const scopeLabel = scopeLabels[coupon?.leaderboardScope || 'daily'] || scopeLabels.daily;

    const handleViewReward = () => {
        close();
    };

    return (
        <div className={styles.container}>
            <CouponWonFirstScreen
                scopeLabel={scopeLabel}
                coupon={coupon}
                clientID={clientID || ''}
                onViewReward={handleViewReward}
                onBack={close}
            />
        </div>
    );
}
